import { render } from "./TextAreaField.vue?vue&type=template&id=7fa434c8"
import script from "./TextAreaField.vue?vue&type=script&lang=js"
export * from "./TextAreaField.vue?vue&type=script&lang=js"
script.render = render

export default script